module.exports = __webpack_public_path__ + "assets/img/news (48).63e55421.png";